export enum Methods {
  GET = "get",
  POST = "post",
  PUT = "put",
  DELETE = "delete",
  PATCH = "patch",
}

export interface RequestResponse<T = any> {
  version?: string;
  result?: boolean;
  message?: string;
  code: number;
  data: T;
  serverTime?: number;
  requestId?: string;
}
